module.exports = __webpack_public_path__ + "img/gb9877_1-88-12x24x7.prt.2c7a0691.jpg";